/* eslint-disable import/no-anonymous-default-export */
import configuredAxios from 'helpers/configuredAxios'

import { fetchRecruiterSubscriptionFeature } from './fetchRecruiterSubscriptionFeature'

export const recruiterDetail = (id) => {
  const axios = configuredAxios('recruiters')
  return axios.get(`/${id}/recruiter-info`)
}

export const recruiterJobs = (params) => {
  const axios = configuredAxios('apiGo')
  return axios.get(`/web/jobs/search/by_recruiter`, { params })
}

export const fetchRecruiterDetail = async (recruiterId, lang,) => {
  const axios = await configuredAxios('apiGo')
  const data = await axios.get(`/web/recruiters/${recruiterId}/recruiter_info?lang=${lang}`)
    .then(res => res.data.data)

  return data
}

export const fetchRecruiterDetailV2 = (recruiterId, lang) => {
  const axios = configuredAxios('apiGo')
  return axios.get(`/web/recruiters/${recruiterId}/recruiter_info/v2?lang=${lang}`)
}



export default {
  fetchRecruiterSubscriptionFeature,
}

